import React from "react";
import Text from "../components/atoms/Text";
import Button from "../components/atoms/Button";
import FeedbackCard from "../components/molecules/FeedbackCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCheck,
  faLeaf,
  faHeadset,
  faBoxOpen,
  faShieldHeart,
  faTruckFast,
} from "@fortawesome/free-solid-svg-icons";
import about1 from "../assets/about1.png";
import about2 from "../assets/about2.png";
import about3 from "../assets/about3.png";
import about4 from "../assets/about4.png";
import about5 from "../assets/about5.png";
import about6 from "../assets/about6.png";
import about7 from "../assets/about7.png";

const strengths = [
  {
    icon: faLeaf,
    title: "100% Organic Food",
    text: "Healthy ingredients sourced with care for every order.",
  },
  {
    icon: faHeadset,
    title: "Great Support 24/7",
    text: "Friendly help whenever you need delivery or order support.",
  },
  {
    icon: faBoxOpen,
    title: "Customer Feedback",
    text: "We keep improving based on real stories from happy shoppers.",
  },
  {
    icon: faShieldHeart,
    title: "100% Secure Payment",
    text: "Safe checkout and trusted payment methods from start to finish.",
  },
  {
    icon: faTruckFast,
    title: "Free Shipping",
    text: "Fast local delivery on qualifying baskets and weekly essentials.",
  },
  {
    icon: faCheck,
    title: "100% Organic Food",
    text: "Fresh produce packed carefully to protect quality and taste.",
  },
];

const teamMembers = [
  { image: about4, name: "Jenny Wilson", role: "Chief Farmer" },
  { image: about5, name: "Jane Cooper", role: "Worker" },
  { image: about6, name: "Cody Fisher", role: "Security Guard" },
  { image: about7, name: "Robert Fox", role: "Senior Farm Manager" },
];

export default function About() {
  return (
    <div className="about-page">
      <section className="about-story-section about-story-section--top">
        <div className="about-story-copy">
          <Text
            size="px14"
            weight="w600"
            color="primary"
            extraStyles={{ letterSpacing: "0.08em", textTransform: "uppercase" }}
          >
            100% Trusted
          </Text>
          <Text
            size="px40"
            weight="w600"
            color="greenG9"
            extraStyles={{ lineHeight: "1.15", marginTop: "12px" }}
          >
            Organic Food Store
          </Text>
          <Text
            size="px16"
            weight="w400"
            color="gray5"
            extraStyles={{ lineHeight: "1.7", marginTop: "18px" }}
          >
            Morbi porttitor ligula in nunc varius sagittis. Proin dui nisi,
            aliquam vitae, cursus vel, feugiat id, nunc. Pellentesque habitant
            morbi tristique senectus et netus et malesuada fames ac turpis
            egestas.
          </Text>
        </div>
        <div
          className="about-photo-frame about-photo-frame--compact about-photo-frame--background"
          style={{ backgroundImage: `url(${about1})` }}
          aria-label="about1"
        >
          <div className="about-photo-background-fill"></div>
        </div>
      </section>

      <section className="about-story-section about-story-section--feature">
        <div
          className="about-photo-frame about-photo-frame--wide about-photo-frame--background"
          style={{ backgroundImage: `url(${about2})` }}
          aria-label="about2"
        >
          <div className="about-photo-background-fill"></div>
        </div>
        <div className="about-story-copy about-story-copy--feature">
          <Text
            size="px14"
            weight="w600"
            color="primary"
            extraStyles={{ letterSpacing: "0.08em", textTransform: "uppercase" }}
          >
            100% Trusted
          </Text>
          <Text
            size="px40"
            weight="w600"
            color="greenG9"
            extraStyles={{ lineHeight: "1.15", marginTop: "12px" }}
          >
            Organic Food Store
          </Text>
          <Text
            size="px16"
            weight="w400"
            color="gray5"
            extraStyles={{ lineHeight: "1.7", marginTop: "18px" }}
          >
            Pellentesque a ante vulputate leo porttitor luctus sed eget eros.
            Nulla et rhoncus neque. Duis non diam eget est luctus tincidunt a a
            mi.
          </Text>

          <div className="about-strength-grid">
            {strengths.map((item) => (
              <div key={item.title + item.text} className="about-strength-card">
                <span className="about-strength-icon">
                  <FontAwesomeIcon icon={item.icon} />
                </span>
                <div>
                  <Text
                    size="px16"
                    weight="w500"
                    color="greenG9"
                    extraStyles={{ lineHeight: "1.4" }}
                  >
                    {item.title}
                  </Text>
                  <Text
                    size="px14"
                    weight="w400"
                    color="gray5"
                    extraStyles={{ lineHeight: "1.6", marginTop: "6px" }}
                  >
                    {item.text}
                  </Text>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-story-section about-story-section--delivery">
        <div className="about-story-copy">
          <Text
            size="px40"
            weight="w600"
            color="greenG9"
            extraStyles={{ lineHeight: "1.15" }}
          >
            We Delivered, You Enjoy Your Order.
          </Text>
          <Text
            size="px16"
            weight="w400"
            color="gray5"
            extraStyles={{ lineHeight: "1.7", marginTop: "18px" }}
          >
            Ut suscipit egestas suscipit. Sed posuere pellentesque nunc,
            ultrices consectetur velit dapibus eu. Mauris sollicitudin dignissim
            diam, ac mattis eros accumsan rhoncus.
          </Text>

          <div className="about-checklist">
            {[
              "Mauris volutpat cursus sem",
              "Aenean molestie lectus tristique",
              "Vestibulum ante ipsum primis in faucibus",
            ].map((item) => (
              <div key={item} className="about-checklist-item">
                <span className="about-checkmark">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                <Text size="px14" weight="w400" color="gray5">
                  {item}
                </Text>
              </div>
            ))}
          </div>

          <Button variant="fill" size="medium" style={{ marginTop: "28px" }}>
            Shop Now
            <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: "12px" }} />
          </Button>
        </div>
        <div
          className="about-photo-frame about-photo-frame--delivery about-photo-frame--background"
          style={{ backgroundImage: `url(${about3})` }}
          aria-label="about3"
        >
          <div className="about-photo-background-fill"></div>
        </div>
      </section>

      <section className="about-team-section">
        <Text
          size="px40"
          weight="w600"
          color="greenG9"
          extraStyles={{ lineHeight: "1.15" }}
        >
          Our Awesome Team
        </Text>
        <Text
          size="px16"
          weight="w400"
          color="gray5"
          extraStyles={{
            lineHeight: "1.7",
            maxWidth: "540px",
            margin: "14px auto 0",
          }}
        >
          Pellentesque a ante vulputate leo porttitor luctus sed eget eros.
          Nulla et rhoncus neque. Duis non diam eget est luctus tincidunt.
        </Text>

        <div className="about-team-grid">
          {teamMembers.map((member) => (
            <div key={member.name} className="about-team-card">
              <div
                className="about-team-photo-wrap about-photo-frame--background"
                style={{ backgroundImage: `url(${member.image})` }}
                aria-label={member.name}
              />
              <div className="about-team-meta">
                <Text size="px16" weight="w500" color="greenG9">
                  {member.name}
                </Text>
                <Text
                  size="px14"
                  weight="w400"
                  color="gray5"
                  extraStyles={{ marginTop: "4px" }}
                >
                  {member.role}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-testimonials-section">
        <Text size="px40" weight="w600" color="greenG9">
          Client Testimonial
        </Text>
        <div className="about-testimonials-grid">
          <FeedbackCard
            compact={true}
            feedbackText="Pellentesque eu nibh eget mauris congue mattis mattis nec tellus. Phasellus imperdiet elit eu magna dictum, bibendum cursus velit sodales. Donec sed neque eget"
            userIcon={require("../assets/user1.png")}
            userName="Jenny Wilson"
          />
          <FeedbackCard
            compact={true}
            feedbackText="Pellentesque eu nibh eget mauris congue mattis mattis nec tellus. Phasellus imperdiet elit eu magna dictum, bibendum cursus velit sodales. Donec sed neque eget"
            userIcon={require("../assets/user2.png")}
            userName="Guy Hawkins"
          />
          <FeedbackCard
            compact={true}
            feedbackText="Pellentesque eu nibh eget mauris congue mattis mattis nec tellus. Phasellus imperdiet elit eu magna dictum, bibendum cursus velit sodales. Donec sed neque eget"
            userIcon={require("../assets/user3.png")}
            userName="Kathryn Murphy"
          />
        </div>
      </section>
    </div>
  );
}
